<template>
  <main class="container">
    <div class="w">
      <b-row>
        <b-col>
          <span class="sub-title"
            >Deseja realmente realizar aborto do processo a seguir ?</span
          >
          <div class="box">
            <ul>
              <li>Descrição: {{ item.descricao }}</li>
              <li>Tipo de material genérico: {{ item.tipoMaterialGenerico || item.tipoMaterial}}</li>
              <li>Quantidade de materiais: {{ item.quantidade || item.processoCiclo.qt_material_generico}}</li>
              <li v-if="item.hasOwnProperty('area')">Área / Processo: {{ item.area.nome }}
                  / {{ item.tipoProcesso.nome }}</li>
              <li v-else>Área / Processo: {{item.subSetor}} / {{item.tipoProcesso}}</li>
              <li>Data: {{ item.data || item.date}}</li>
            </ul>
          </div>
          <br />
          <div>
            <b-form-group label="Quantidade de cancelamentos*">
              <b-form-input
                v-model="qt_materiais_cancelamento"
                size="lg"
                :state="Boolean(qt_materiais_cancelamento)"
                type="number"
                min="1"
                :max="item.qt_material_generico"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group label="Justificativa*">
              <b-form-input
                v-model="observacao_aborto_processo"
                size="lg"
                :state="Boolean(observacao_aborto_processo)"
              >
              </b-form-input>
            </b-form-group>
          </div>
          <Button
            id="button"
            @click="removeProcess()"
            text="Confirmar"
            :loading="isBusy"
          />
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import LoginService from '@/services/login';
import GenericApi from '@/services/genericRequest';
import Button from '@/components/Utils/Button';

export default {
  components: {
    Button,
  },
  data() {
    return {
      qt_materiais_cancelamento: this.item.qt_material_generico,
      observacao_aborto_processo: '',
      isBusy: false,
    };
  },
  props: {
    item: {
      type: Object,
    },
  },
  methods: {
    async removeProcess() {
      if (
        !this.observacao_aborto_processo
        || (
          this.qt_materiais_cancelamento
          && this.qt_materiais_cancelamento > this.item.qt_material_generico
        )
      ) {
        await swal({
          title: 'Erro',
          text: 'Quantidade de materiais a serem cancelados e justificativa são obrigatórias para aborto de processo!',
          icon: 'error',
          button: 'Continuar...',
        });

        return;
      }
      const usuario = LoginService.getUser();
      this.isBusy = true;
      try {
        await GenericApi.update(
          this.item.id_processo_ciclo,
          {
            qt_materiais_cancelamento: this.qt_materiais_cancelamento,
            observacao_aborto_processo: this.observacao_aborto_processo,
            id_usuario: usuario.id_usuario,
            processoCiclo: this.item,
          },
          'processoCiclo/abortoProcessoCiclo/materialGenerico',
        );

        this.$router.go();
      } catch (error) {
        let errorMessage = 'Erro ao abortar lote. Contacte o suporte';
        if (error.response && error.response.data && error.response.data.error
          && error.response.data.error.errorMessage) {
          errorMessage = error.response.data.error.errorMessage;
        }

        swal({
          icon: 'error',
          title: 'Erro',
          text: errorMessage,
          buttons: { confirm: 'Fechar' },
        });
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>

<style scoped>
* {
  font-weight: 400;
  font-size: 16px;
}

.box {
  border: 1px dashed #afb4d6;
  border-radius: 5px;
}

.box li {
  list-style: none;
}

.box ul {
  padding: 1rem 1rem;
  margin: 0;
}

#button {
  margin-top: 2rem;
  float: right;
}

.sub-title {
  font-size: 20px;
  display: flex;
  margin-top: -1rem;
  margin-bottom: 2rem;
  max-width: 300px;
  color: #21cca9;
  text-align: center;
  margin-left: 12%;
}

li {
  margin-bottom: 0.5rem;
}

.padding {
  padding: 36px;
  font-weight: 400;
}

label {
  margin-bottom: 3px;
}

.info {
  margin-bottom: 12px;
}

.underline {
  flex-grow: 1;
  /* width: 100%; */
  border-bottom: 1px solid black;
  margin-left: 5px;
  margin: 0 10px 4px 5px;
}

.div-assinaturas {
  display: flex;
  margin-bottom: 10px;
}

.w h2 {
  font-size: 16px;
  font-weight: 600;
}

.modal-header {
  border-bottom: 0;
}

.header .title {
  font-weight: 500;
  font-size: 18px;
  margin-top: -30px;
  margin-bottom: 40px;
  margin-left: -10px;
}
</style>
